<script lang="ts">
import { type VariantProps, cva } from "class-variance-authority";

// shadcn-vue Button, themed to the Cyberfide brand tokens (REQ-CD-P1-CON-08)
// instead of the Shadcn defaults. Named exports must live in a plain
// <script> block — <script setup> cannot contain ES module exports.
export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2 focus-visible:ring-offset-card disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-brand-blue text-white hover:bg-brand-blue/90",
        outline: "border border-brand-blue text-brand-blue hover:bg-brand-blue/10",
        destructive: "bg-status-error text-white hover:bg-status-error/90",
        ghost: "text-brand-light hover:bg-brand-slate/10",
      },
      size: {
        default: "h-10 min-h-[44px] px-4 text-sm",
        sm: "h-8 min-h-[44px] px-3 text-xs",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface ButtonProps {
  variant?: VariantProps<typeof buttonVariants>["variant"];
  size?: VariantProps<typeof buttonVariants>["size"];
  class?: string;
}
</script>

<script setup lang="ts">
import { computed } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<ButtonProps>();
const classes = computed(() => cn(buttonVariants({ variant: props.variant, size: props.size }), props.class));
</script>

<template>
  <button type="button" :class="classes">
    <slot />
  </button>
</template>
